<template>
  <div v-for="product in products" :key="product.trackerProductId" tabindex="0">
    <SearchBarProductsItem
      :tracker-product-id="product.trackerProductId"
      :product-id="product.productId"
      :price="product.productPrice"
      :title="product.productTitle || '-'"
      @view-product-details="
        (appIdProductId, trackerProductId) => $emit('viewProductDetails', appIdProductId, trackerProductId)
      "
    />
  </div>
</template>

<script setup lang="ts">
import { DTODataScienceSearchProductHit } from "vue-app/api/dto";
import SearchBarProductsItem from "vue-app/components/SearchBar/SearchBarProducts/SearchBarProductsItem.vue";

interface Props {
  products: DTODataScienceSearchProductHit[];
}

interface Emits {
  viewProductDetails: [appIdProductId: string, trackerProductId: number];
}

defineProps<Props>();
defineEmits<Emits>();
</script>
